// extracted by mini-css-extract-plugin
export default {"ObjetHabitus":"ObjetHabitus_ObjetHabitus__y2Yor"};